<template lang="pug">
  components(
    :is="$_inputComponent",
    v-bind="$attrs",
    @left="positoin"
  )
    slot(
      v-for="(_, name) in $slots",
      :name="name",
      :slot="name",
    )
    .arrow(:style="{'--arrow-left': `${left}px`}")
</template>

<script>
import BaseTooltipHover from 'Components/Base/BaseTooltipHover';
import BaseTooltipToggle from 'Components/Base/BaseTooltipToggle';

export default {
  name: 'BaseTooltip',
  components: {
    BaseTooltipHover,
    BaseTooltipToggle,
  },
  props: {
    openOnClick: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      left: 0,
    };
  },
  computed: {
    $_inputComponent() {
      return this.openOnClick ? 'BaseTooltipToggle' : 'BaseTooltipHover';
    },
  },
  methods: {
    positoin(data) {
      this.left = data;
    },
  },
};
</script>

<style lang="sass">
@import '~Styles/_variables'
.v-tooltip
  max-width: 193px
  cursor: help
  border-bottom: dashed 2px $support_yellow
  &.no-underline
    border-bottom: none
  &.tooltip-disabled
    border-bottom: none
    cursor: default
  &__content
    background: $gray-10
    color: $body_color
    font-size: 12px
    line-height: 17px
    font-family: Roboto
    opacity: 1
    +font(400)
    max-width: 290px
    border: 1px solid $support_lightgray
    box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.30)
    padding: 8px
    margin-bottom: 0
    text-align: start
    & .arrow
      position: absolute
      left:0
      top:0
      right:0
      bottom:0
      &::after
        content: " "
        position: absolute
        top: 100%
        left: var(--arrow-left)
        right: initial
        margin-left: -6px
        border-width: 6px
        border-style: solid
        border-color: $gray-10 transparent transparent transparent
        filter: drop-shadow(0px 2px 1px rgba(0, 0, 0, 0.30))
    &.tooltip-bottom
      top: 30px
      & .arrow
        &::after
          top: -30px
          bottom:100%
          margin-left: 6px
          transform: rotate(180deg)
          filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.10))
    &.menuable__content__active
      transition: .1s ease-out
      transition-delay: 0.1s
      opacity: 1 !important
    &.sign-up
      max-width: 300px
      margin-top: 20px
      padding: 0
      position: absolute
      top: -115px !important
      @media screen and (max-width: 360px)
        max-width: 270px
    &.menuable__content__active
      &:after
        color: $white
        text-shadow: 0 1px 2px rgba(0,0,0,0.02)
        visibility: visible !important
    &.tooltip-right
      padding: 15px 20px 15px 25px
      &:after
        left: -10px
        top: 15px
        transform: rotate(90deg)
    &.tooltip-disabled
      display: none
    .info-circle-icon
      fill: $text_gray
    &.user-status-tooltip-content
      @media screen and (min-width: 577px)
        display: none
    &.ein-tooltip
      max-width: 315px
      a
        pointer-events: auto
      span
        a
          pointer-events: auto
        span
          margin-top: 5px
          display: flex
      .new-line
        margin-top: 5px
        display: flex
    &.primary-beneficiary-tooltip
      max-width: 250px
      span
        strong
          color: $text_gray
        a
          pointer-events: auto
    &.plans-trustee-tooltip
      max-width: 210px
    &.entity-name-tooltip
      max-width: 210px
    &.pending-closing-tooltip
      max-width: 247px
      strong
        color: $primary
    &.beneficial-status
      max-width: 247px
    &.copy--tooltip
      min-width: 65px
      text-align: center
.country-tooltip
  margin-top: 18px
  max-width: 263px
.unsuccessful-tooltip-content
  max-width: 210px
.v-tooltip-activator
  cursor: help
  border-bottom: dashed 2px $support_yellow
  &.tooltip-disabled
    cursor: auto
    border-bottom: none
.score-tooltip
  max-width: 350px
  @media screen and (max-width: 360px)
    max-width: 300px
  &:after
    @media screen and (max-width: 767px)
      left: 78% !important
    @media screen and (max-width: 576px)
      left: 89% !important
  &.tooltip-bottom
    &:after
      @media screen and (max-width: 767px)
        left: 76% !important
      @media screen and (max-width: 576px)
        left: 87% !important
  h6
    font-size: 12px
    line-height: 17px
.investment-tooltip-content
  max-width: 513px
</style>
